import React, { useEffect } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import MessageInfo from '../MessageInfo';
import { xs_isMobile } from '../..';
import { getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';

export default function LoadBet() {
    const betslipContext = React.useContext(BetslipContext);

    useEffect(() => {
        const conf = getConfiguration();
        const sp = new URLSearchParams(window.location.search);
        const ticketId = sp.get('ticketId');

        betslipContext.reloadTicket(ticketId);

        const routes = window.appConfig.ROUTES;
        let url = '';
        const reloadBetConf = conf.rlbc?.length > 0 ? JSON.parse(conf.rlbc) : null;
        if (xs_isMobile) {
            url = `https://${conf.url}${routes.prematch.prematch}`;
            if (reloadBetConf?.mobileUrl?.length > 0) {
                url = reloadBetConf.mobileUrl;
            }
        } else {
            url = `https://${conf.url}${routes.prematch['top-match']}`;
            if (reloadBetConf?.desktopUrl?.length > 0) {
                url = reloadBetConf.desktopUrl;
            }
        }
        setTimeout(() => window.location.href = url, 1000);
    }, []);

    return (
        <>
            <MessageInfo message={getLabel('rebet.loading')} />
        </>
    );
}
